import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { API_BASE_URL } from '@app/app.constants';
import { AuthenticationService } from '@app/auth/services/authentication.service';
import { RouteConfig } from '@app/core/interfaces/c5/acd/route-config';
import { NightModeStatus } from '@app/core/interfaces/c5/night-mode-status';
import { TimeTable } from '@app/core/interfaces/c5/time-table';
import { Utils } from '@app/shared/services/utils.service';
import { wrapError } from '@app/utils/rxjs';
import { CallCenterRouteConfig } from '@business/call-center/call-center-route-config/models/call-center-route-config';
import { Observable, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class CallCenterQueueRouteConfigRepository {
  constructor(
    private authenticationService: AuthenticationService,
    private http: HttpClient,
    private utils: Utils
  ) {}

  getNightModeStatus(callCenterId: number, queueId: number): Observable<NightModeStatus> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/queue/${queueId}/nightModeStatus`).pipe(
      mergeMap(
        (url) =>
          this.http.get(url, {
            responseType: 'text',
          }) as Observable<NightModeStatus>
      ),
      wrapError('call-center-route-config-repository:get-night-mode-status')
    );
  }

  list(callCenterId: number, queueId: number): Observable<RouteConfig[]> {
    let url$: Observable<string>;

    if (this.authenticationService.userIsEndUser()) {
      url$ = of(API_BASE_URL + `/user/callCenter/${callCenterId}/queue/${queueId}/routeConfigs`);
    } else {
      url$ = this.utils.apiUrl(`/callCenter/${callCenterId}/queue/${queueId}/routeConfigs`);
    }

    return url$.pipe(
      mergeMap((url) => this.http.get<RouteConfig[]>(url)),
      wrapError('call-center-queue-route-config-repository:list')
    );
  }

  listTimeTables(queueId: number): Observable<TimeTable[]> {
    return this.utils.apiUrl(`/timeTables?queueId=${queueId}`).pipe(
      mergeMap((url) => this.http.get<TimeTable[]>(url)),
      wrapError('call-center-route-config-repository:list-time-tables')
    );
  }

  update(callCenterId: number, queueId: number, routeConfigs: CallCenterRouteConfig[]): Observable<void> {
    return this.utils.apiUrl(`/callCenter/${callCenterId}/queue/${queueId}/routeConfigs`).pipe(
      mergeMap((url) => this.http.put<void>(url, routeConfigs)),
      wrapError('call-center-route-config-repository:update')
    );
  }

  updateNightModeStatus(
    callCenterId: number,
    queueId: number,
    nightModeStatus: NightModeStatus
  ): Observable<void> {
    return this.utils
      .apiUrl(`/callCenter/${callCenterId}/queue/${queueId}/nightModeStatus?status=${nightModeStatus}`)
      .pipe(
        mergeMap((url) => this.http.put<void>(url, {})),
        wrapError('call-center-route-config-repository:update-night-mode-status')
      );
  }
}
